document.addEventListener('DOMContentLoaded', () => {
	const citations = document.querySelectorAll('.citation');

	if (!citations.length) return;

	let tooltip = document.querySelector('#citation-tooltip');
	let tooltipContent = document.querySelector('#citation-tooltip-content');

	if (!tooltip) {
		tooltip = document.createElement('div');
		tooltip.className = 'citation-tooltip';
		tooltip.id = 'citation-tooltip';
		tooltip.setAttribute('role', 'tooltip');
		tooltip.setAttribute('aria-hidden', 'true');

		tooltip.innerHTML = `
			<div class="citation-tooltip__inner" id="citation-tooltip-content"></div>
		`;

		document.body.appendChild(tooltip);
		tooltipContent = tooltip.querySelector('#citation-tooltip-content');
	}

	let activeCitation = null;

	const positionTooltip = (citation) => {
		if (!tooltip.classList.contains('is-visible')) return;

		const rect = citation.getBoundingClientRect();
		const tooltipRect = tooltip.getBoundingClientRect();
		const offset = 12;
		const minPadding = 16;

		let left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
		let top = rect.top - tooltipRect.height - offset;

		const maxLeft = window.innerWidth - tooltipRect.width - minPadding;

		if (left < minPadding) left = minPadding;
		if (left > maxLeft) left = maxLeft;

		if (top < minPadding) {
			top = rect.bottom + offset;
		}

		tooltip.style.left = `${left}px`;
		tooltip.style.top = `${top}px`;
	};

	const showTooltip = (citation) => {
		const footnoteNumber = citation.getAttribute('data-footnote');
		if (!footnoteNumber) return;

		const footnote = document.querySelector(`#citation-tooltip-${footnoteNumber}`);
		if (!footnote) return;

		tooltipContent.innerHTML = footnote.innerHTML;
		tooltip.setAttribute('aria-hidden', 'false');
		tooltip.classList.add('is-visible');

		citations.forEach((item) => {
			item.setAttribute('aria-expanded', 'false');
		});

		citation.setAttribute('aria-expanded', 'true');
		activeCitation = citation;

		positionTooltip(citation);
	};

	const hideTooltip = () => {
		tooltip.classList.remove('is-visible');
		tooltip.setAttribute('aria-hidden', 'true');

		citations.forEach((citation) => {
			citation.setAttribute('aria-expanded', 'false');
		});

		activeCitation = null;
	};

	citations.forEach((citation) => {
		citation.addEventListener('mouseenter', () => {
			showTooltip(citation);
		});

		citation.addEventListener('focus', () => {
			showTooltip(citation);
		});

		citation.addEventListener('mouseleave', () => {
			hideTooltip();
		});

		citation.addEventListener('blur', () => {
			hideTooltip();
		});
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			hideTooltip();
		}
	});

	window.addEventListener('scroll', () => {
		if (activeCitation) {
			hideTooltip();
		}
	}, { passive: true });

	window.addEventListener('resize', () => {
		if (activeCitation) {
			positionTooltip(activeCitation);
		}
	});
});